import { Host, h } from '@stencil/core';
export class PesRadio {
  constructor() {
    this.items = [];
    this.groupId = undefined;
    this.selectedValue = undefined;
  }
  onChange(e) {
    this.pesRadioChange.emit(e.detail);
  }
  render() {
    return (h(Host, null, this.items.map((item) => {
      var _a, _b;
      return (h("pes-radio-button", { onButtonChange: (e) => this.onChange(e), value: item.value, text: item.text, name: this.groupId, checked: ((_a = this.selectedValue) === null || _a === void 0 ? void 0 : _a.toString()) === ((_b = item.value) === null || _b === void 0 ? void 0 : _b.toString()) }));
    })));
  }
  static get is() { return "pes-radio"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-radio.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-radio.css"]
    };
  }
  static get properties() {
    return {
      "items": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "{ value: string | number; text: string }[]",
          "resolved": "{ value: string | number; text: string; }[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[]"
      },
      "groupId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Radio button group id."
        },
        "attribute": "group-id",
        "reflect": false
      },
      "selectedValue": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "string | number",
          "resolved": "number | string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Selected value."
        },
        "attribute": "selected-value",
        "reflect": false
      }
    };
  }
  static get events() {
    return [{
        "method": "pesRadioChange",
        "name": "pesRadioChange",
        "bubbles": false,
        "cancelable": true,
        "composed": false,
        "docs": {
          "tags": [],
          "text": "Fired on pes-link click.\nContains page, pageId link parameters as event.detail."
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
}
